import { NameCell } from "@/components/cells/name";
import { getBillableExtensionDays, ROUTE } from "@/lib/utils";
import React from "react";
import { Link } from "react-router-dom";
import { formatDateForDisplay } from "utils/utils";

const BillableName = ({ row, href, billableId }) => {
  const name = row.getValue("name");

  const extensionDays = getBillableExtensionDays(row.original);

  if (href) {
    const linkHref = href === true ? ROUTE.BILLABLE(billableId) : href;

    <div>
      <Link to={linkHref} className="hover:underline" target="_blank">
        {name}
      </Link>
      {extensionDays ? (
        <div className="text-red-600">
          Extended by {extensionDays} days last extended on{" "}
          {formatDateForDisplay(
            row.original.extensions[row.original.extensions.length - 1]
              .date_created,
          )}
        </div>
      ) : null}
    </div>;
  }

  return (
    <div className="space-y-1" title={name}>
      <NameCell getValue={() => name} />
      {extensionDays ? (
        <div className="text-red-600">
          Extended by {extensionDays} days last extended on{" "}
          {formatDateForDisplay(
            row.original.extensions[row.original.extensions.length - 1]
              .date_created,
          )}
        </div>
      ) : null}
    </div>
  );
};

export default BillableName;
